module.exports = __webpack_public_path__ + "static/media/precios_baterias.30e253be.png";